import React, { Component, Fragment } from 'react';
import { YouTubePlayer } from '../../atoms';
import { NewInfoBlock, Select, Modal, Pagination } from '../../molecules';

import './styles.css';

const PageSize = 6;
const options = [
	{ key: 'all', value: 'All Categories' },
	{ key: 'category1', value: 'TAGGIS' },
	{ key: 'category2', value: 'ELearning' },
	{ key: 'category3', value: 'Collaboration' },
];

const formatNews = (news) => {
	const twoColumnNews = {
		firstColumn: [],
		secondColumn: [],
	};

	news.forEach((newsItem, index) => {
		if (index % 2 !== 0) twoColumnNews.secondColumn.push(newsItem);
		else twoColumnNews.firstColumn.push(newsItem);
	});

	return twoColumnNews;
};

const MQ_MOBILE_SCREEN = '(max-width: 720px)';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
export default class NewsPage extends Component {
	constructor (props) {
		super(props);
		this.state = {
			currentPage: 1,
			expandedItemId: null,
			isMobile: window.matchMedia(MQ_MOBILE_SCREEN).matches,
			newsCollection: props.content.newsPage.news,
			videoId: null,
		};
	}

	componentDidMount () {
		this.mql.addListener(this.handleMediaChange);
	}

	componentWillUnmount () {
		this.mql.removeListener(this.handleMediaChange);
	}

	mql = window.matchMedia(MQ_MOBILE_SCREEN);

	handleMediaChange = ({ matches }) => this.setState({ isMobile: !!matches });

	currentNewsCollectionData = () => {
		const { currentPage, newsCollection, isMobile } = this.state;
		const firstPageIndex = (currentPage - 1) * PageSize;
		const lastPageIndex = firstPageIndex + PageSize;

		const collection = newsCollection.slice(firstPageIndex, lastPageIndex);

		return isMobile ? collection : formatNews(collection);
	};

	handleCloseModal = () => this.setState({ videoId: null });

	handleChangeCategory = (option) => {
		const { news } = this.props.content.newsPage;

		if (option.key === 'all') {
			this.setState({
				currentPage: 1,
				newsCollection: news,
			});
			return;
		}
		const filteredNews = news.filter((item) =>
			item.categories.some((cat) => cat.value === option.key)
		);

		this.setState({
			currentPage: 1,
			newsCollection: filteredNews,
		});
	};

	setCurrentPage = (/** @type {Number} */ page) => this.setState({ currentPage: page });

	setExpandedItemId = (/** @type {Number|null} */ expandedItemId) => this.setState({ expandedItemId });

	setVideoId = (/** @type {String|null} */ videoId) => this.setState({ videoId });

	renderNews = () => {
		const { expandedItemId } = this.state;
		return Array.isArray(this.currentNewsCollectionData()) ? (
			this.currentNewsCollectionData().map((infoBlock) => (
				<NewInfoBlock
					key={infoBlock.id}
					infoBlock={infoBlock}
					expandedItemId={expandedItemId}
					setVideoId={this.setVideoId}
					setExpandedItemId={this.setExpandedItemId}
				/>
			))
		) : (
			<Fragment>
				<div>
					{this.currentNewsCollectionData().firstColumn.map(
						(infoBlock) => (
							<NewInfoBlock
								key={infoBlock.id}
								infoBlock={infoBlock}
								expandedItemId={expandedItemId}
								setVideoId={this.setVideoId}
								setExpandedItemId={this.setExpandedItemId}
							/>
						)
					)}
				</div>
				<div>
					{this.currentNewsCollectionData().secondColumn.map(
						(infoBlock) => (
							<NewInfoBlock
								key={infoBlock.id}
								infoBlock={infoBlock}
								expandedItemId={expandedItemId}
								setVideoId={this.setVideoId}
								setExpandedItemId={this.setExpandedItemId}
							/>
						)
					)}
				</div>
			</Fragment>
		);
	};

	render () {
		const {
			heading: { title, subTitle },
		} = this.props.content.newsPage;

		const { currentPage, newsCollection, videoId } = this.state;

		return (
			<Fragment>
				<div className='newsPadded'>
					<div className='SubHeading'>{subTitle}</div>
					<div className='headContainer'>
						<h2 className='Heading'>{title}</h2>
						<Select
							options={options}
							onChange={this.handleChangeCategory}
						/>
					</div>
					<Pagination
						className='PaginationBar'
						currentPage={currentPage}
						totalCount={newsCollection.length}
						pageSize={PageSize}
						onPageChange={(page) => this.setCurrentPage(page)}
					/>
					<div className='NewsContainer'>{this.renderNews()}</div>
					<Pagination
						className='PaginationBar'
						currentPage={currentPage}
						totalCount={newsCollection.length}
						pageSize={PageSize}
						onPageChange={(page) => this.setCurrentPage(page)}
					/>
					<Modal onClose={this.handleCloseModal} show={!!videoId}>
						{videoId && (
							<YouTubePlayer
								className='youtube-video'
								videoId={videoId}
								isToggled={false}
							/>
						)}
					</Modal>
				</div>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/NewsPage/NewsPage.js